module.exports = __webpack_public_path__ + "img/129.2.493cd183.png";